import {openResourceModal} from '../../core/modalCommand';
import {
	SWITCH_IPV6_ACL_CREATE_MODAL_EVENT,
	SWITCH_IPV6_ACL_DELETE_MODAL_EVENT,
	SWITCH_IPV6_ACL_ADD_ACE_EVENT,
	SWITCH_IPV6_ACL_EDIT_ACE_EVENT,
	SWITCH_IPV6_ACL_DELETE_ACE_EVENT,
} from './events';

/**
 * Open Add Switch IPv6 ACL.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv6AclCreateModal(command, envelope) {
	return openResourceModal(SWITCH_IPV6_ACL_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete Switch IPv6 ACL.
 *
 * The confirmation, not the deletion. Nothing is removed until
 * the person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv6AclDeleteModal(command, envelope) {
	return openResourceModal(SWITCH_IPV6_ACL_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Open the form for a new rule inside one SwitchIpv6Acl.
 *
 * A rule belongs to an ACL, so the ACL is named first and the form opens
 * against it. Nothing is saved here.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv6AclAddAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV6_ACL_ADD_ACE_EVENT, command, envelope);
}

/**
 * Open one existing rule for editing.
 *
 * Which rule is the sequence the request supplied; the ACL around it is the
 * resolved entity.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv6AclEditAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV6_ACL_EDIT_ACE_EVENT, command, envelope);
}

/**
 * Open the confirmation for deleting one rule.
 *
 * The rule, never the ACL around it. The confirmation is where it stops.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSwitchIpv6AclDeleteAceModal(command, envelope) {
	return openResourceModal(SWITCH_IPV6_ACL_DELETE_ACE_EVENT, command, envelope);
}
